import React, { useState } from 'react'
import { Button } from '@mui/material'
import { FileDownload as ExportIcon } from '@mui/icons-material'
import { ExportModal } from './ExportModal'
import { ExportDataType } from '../types/export.types'

interface ExportButtonProps {
  dataType: ExportDataType
  label?: string
}

export const ExportButton: React.FC<ExportButtonProps> = ({ dataType, label = 'Export' }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<ExportIcon />}
        onClick={() => setOpen(true)}
        size="small"
      >
        {label}
      </Button>
      <ExportModal open={open} onClose={() => setOpen(false)} dataType={dataType} />
    </>
  )
}

export default ExportButton
